export const TOGGLE_MODAL_CONTATO = "TOGGLE_MODAL_CONTATO";
